module.exports = __webpack_public_path__ + "img/onboarding.d98eaa22.svg";